import type { TeamMember } from "@/data/teamMembers";
import TeamMemberCard from "./TeamMemberCard";

interface TeamGridProps {
  members: TeamMember[];
  className?: string;
}

const TeamGrid = ({ members, className = "" }: TeamGridProps) => (
  <div
    className={`grid grid-cols-1 sm:grid-cols-2 ${members.length >= 3 ? "lg:grid-cols-3" : ""} gap-x-10 gap-y-12 max-w-5xl mx-auto ${className}`.trim()}
  >
    {members.map((member) => (
      <TeamMemberCard key={member.id} member={member} />
    ))}
  </div>
);

export default TeamGrid;
